import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { getDataOption, getDataOptionsFieldDefinition } from "@store/Framework/Common/Utilities/dataOptions";
import { blockVariantSideOptions } from "@store/Library/Components/Toolkit/Block/variant/base";
import { blockVariantOptions } from "@store/Library/Components/Toolkit/Block/variant/config";

const blockVariantSideField = {
    ...getDataOptionsFieldDefinition(blockVariantSideOptions),
    displayName: "Variant Side",
    tooltip: "Determines on which side to apply the variant styles (Default: Both Sides)",
    hideEmptyOption: true,
    isVisible: x => getDataOption(blockVariantOptions, x?.fields?.blockVariant)?.hasSideVariant || false,
} as DropDownFieldDefinition<string>;

export default blockVariantSideField;
